import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login';
import Home from '../components/Home';
import Orders from "../components/Orders";
import Setting from "../components/Setting";
import VModal from 'vue-js-modal'
import ToggleButton from 'vue-js-toggle-button'
import * as VueGoogleMaps from "vue2-google-maps";
import Basket from "../components/Basket";
import ResetPassword from "../components/ResetPassword";
import Driver from "../components/Driver";
import VueSignaturePad from 'vue-signature-pad';
import AdminDrivers from "../components/AdminDrivers";
import Warehouse from "../components/Warehouse.vue";
import OrderStocks from "../components/OrderStocks.vue";
Vue.use(VModal, { dialog: true, width:'90%' })
Vue.use(VueSignaturePad);
Vue.use(Router)
Vue.use(ToggleButton)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA738KR_CAd2VFXcPWjlMPXyBCa27i7ba0",//"AIzaSyC_qnPTkTEwSrXAuT73ILGkmoBV9JpdIL0",
    libraries: "places" // necessary for places input
  }
});

const requireAuth = () => (to, from, next) => {
  if (auth.isAuthorised()) {
    return next();
  }
  next('/');
};


export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: requireAuth()
    },
    {
      path: '/basket',
      name: 'Basket',
      component: Basket,
      beforeEnter: requireAuth()
    },
    {
      path: '/password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting,
      beforeEnter: requireAuth()
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      beforeEnter: requireAuth()
    },
    {
      path: '/driver',
      name: 'Driver',
      component: Driver,
      beforeEnter: requireAuth()
    },
    {
      path: '/wms',
      name: 'Warehouse',
      component: Warehouse,
      beforeEnter: requireAuth()
    },
    {
      path: '/orderstocks',
      name: 'OrderStocks',
      component: OrderStocks,
      beforeEnter: requireAuth()
    },
    {
      path: '/admin/drivers',
      name: 'Drivers',
      component: AdminDrivers,
      beforeEnter: requireAuth()
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js